import React, { useCallback } from 'react';
import { Button, Box, makeStyles, createStyles } from '@material-ui/core';

import {
  CheckCircle as CheckCircleIcon,
  ExpandMore as ExpandMoreIcon,
} from '@material-ui/icons';
import uniqueId from 'lodash/uniqueId';
import clsx from 'clsx';
import { FormValueTypes } from '../../../types';
import { FormInputProps } from '../../../validation';
import { colors } from '../../../theme';

import imageList from '../../../constants/imageList';

const makeCardWithButtonsStyles = makeStyles(() =>
  createStyles({
    miniCard: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.04)',
      borderRadius: '10px',
      border: '1px solid #EAEAEA',
      boxSizing: 'border-box',
      width: '114px',
      height: '80px',
      margin: 7,
      position: 'relative',
    },
    title: {
      color: colors.abbey,
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: '15px',
      lineHeight: '22px',
      letterSpacing: '0.1px',
    },
    checkCircleIcon: {
      position: 'absolute',
      top: 5,
      left: 5,
      color: colors.madison,
    },
    gridButton: {
      marginTop: 12,
      marginBottom: 12,
    },
    buttonSeeAllBrands: {
      color: colors.bright_turquoise,
    },
    fontButtonSeeAllBrands: {
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: '16px',
      lineHeight: '19px',
    },
    containerGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(5, 1fr)',
    },
    itemGrid: {
      gridColumnEnd: 'span 1',
    },
    errorText: {
      color: colors.bright_pink,
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: '12px',
      lineHeight: '22px',
      letterSpacing: '0.1px',
    },
  }),
);

type PropsCardWithButtons = {
  getInputProps: (
    inputName: string,
  ) => FormInputProps<FormValueTypes, FormValueTypes>;
  carBrandFieldName: string;
  updateBrandState: (brandCode?: string, brandID?: number) => void;
  setShowPreferredBrands: (preferedBrand: boolean) => void;
  selectedBrandId: number;
  projectName: string;
};

const CardWithButtons = ({
  getInputProps,
  carBrandFieldName,
  updateBrandState,
  setShowPreferredBrands,
  selectedBrandId,
  projectName,
}: PropsCardWithButtons): JSX.Element => {
  const classes = makeCardWithButtonsStyles();

  const onClickSeeAllBrand = useCallback(() => {
    updateBrandState();
    setShowPreferredBrands(false);
  }, [setShowPreferredBrands, updateBrandState]);

  const onClickSelectBrand = useCallback(
    (id: number, code: string) => {
      updateBrandState(code, id);
    },
    [updateBrandState],
  );

  return (
    <div className={classes.containerGrid}>
      <div style={{ gridColumnEnd: 'span 5' }}>
        <span className={classes.title}>Selecciona la marca</span>
        <div
          className={classes.errorText}
          data-testid="container-card-select-brand"
        >
          {getInputProps(carBrandFieldName).error &&
            getInputProps(carBrandFieldName).errorText}
        </div>
      </div>
      {imageList.map(({ src, height, width, id, code }, index) => (
        <Button
          id={`${projectName}-button-select-preferred-brands-${index}`}
          key={uniqueId()}
          data-testid={`button-${id}`}
          className={clsx(classes.miniCard, classes.itemGrid)}
          style={id === selectedBrandId ? { background: colors.onahau } : {}}
          onClick={(): void => onClickSelectBrand(id, code)}
        >
          <img src={src} alt="" height={height} width={width} />
          {id === selectedBrandId && (
            <CheckCircleIcon
              className={classes.checkCircleIcon}
              data-testid={`checkCircleIcon-${id}`}
            />
          )}
        </Button>
      ))}
      <div className={classes.gridButton} style={{ gridColumnEnd: 'span 5' }}>
        <Box display="flex" justifyContent="center">
          <Button
            id={`${projectName}-see-all-brands`}
            data-testid="button-see-all-brands"
            className={classes.buttonSeeAllBrands}
            onClick={onClickSeeAllBrand}
            endIcon={<ExpandMoreIcon style={{ fontSize: 25 }} />}
          >
            <span className={classes.fontButtonSeeAllBrands}>
              Ver todas las marcas
            </span>
          </Button>
        </Box>
      </div>
    </div>
  );
};

export default CardWithButtons;
